<template>
  <div>
    <div
      style="background-image:url(https://file.lgbfss.com/www/official/images/register.jpg);background-size:100% 100%; height:1000px;"
    >
      <div class="content">
        <div class="container">
          <img
            src="https://file.lgbfss.com/www/official/images/logo.png"
            alt=""
            style="width:200px;margin-top:45px"
          />

          <div class="register-box">
            <div class="register-type">
              <div @click="select(1)" >企业注册</div>
              <div @click="select(2)">个人注册</div>
            </div>

            <div class="login-form">
              <form action="">
                <div>
                  <img src="https://file.lgbfss.com/www/official/images/phone.jpg" alt="" />
                  <input type="text" placeholder="请输入手机号" />
                </div>
                <div>
                  <img src="https://file.lgbfss.com/www/official/images/password.jpg" alt="" />
                  <input type="text" placeholder="请设置密码" />
                </div>
                <div>
                  <img src="https://file.lgbfss.com/www/official/images/password.jpg" alt="" />
                  <input type="text" placeholder="请确认密码" />
                </div>
                <div style="padding-right:50px">
                  <img src="https://file.lgbfss.com/www/official/images/safe.jpg" alt="" />
                  <input type="text" placeholder="请输入验证码" />
                  <span class="send-sms">发送验证码</span>
                </div>
                <button class="login-btn">提交</button>
              </form>
              <div
                class="row"
                style="justify-content: space-between;padding: 0 18px;"
              >
                <div><a href="./find_pwd" class="font-color-4 font-size-14">忘记密码</a></div>
                <div><span class="font-color-4 font-size-14">已有帐号，去</span><a href="./login" class="font-size-14 font-color-3">登录</a></div>
              </div>
              <div style="margin-top: 30px;">
                <label for="read" class="font-color-4 font-size-14">
                  <input type="checkbox" id="read" />我已阅读并同意
                </label>
                 <span class="font-color-3 font-size-14" style="cursor:pointer;">《平台用户协议及隐私政策》</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="layer">
        <div>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor animi nisi sint illo quaerat odio mollitia ab nihil quasi facere nesciunt, voluptatibus saepe. Quisquam similique eos quis repudiandae ipsam nulla!</p>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolor animi nisi sint illo quaerat odio mollitia ab nihil quasi facere nesciunt, voluptatibus saepe. Quisquam similique eos quis repudiandae ipsam nulla!</p>
        </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "register",
   data:()=>{
      return{
      }
  },
  methods:{
    select(i){
       console.log(i);
    }
  }
};
</script>

<style lang="css" scoped>
.register-box {
  background-color: #fff;
  border-radius: 10px;
  padding: 50px 30px 30px 30px;
  width: 400px;
  margin: 0 auto;
}
.register-type{
    display: flex;
    justify-content: space-between;
}
.register-type>div{
    padding: 5px 0;
    border-bottom: 3px solid transparent;
    color: #444444;
    font-size: 18px;
    cursor: pointer;
   
}
.register-type>div:hover{
    border-color: #61c1f0;
    color: #61c1f0;
}
.login-form>form>div{
    padding-left: 50px;
    position: relative;
    height: 45px;
    border: 1px solid #b4b4b4;
    margin: 15px 0;
    border-radius: 10px;
    overflow: hidden;
}

.login-form>form> div>img{
    position: absolute;
    top: 10px;
    left: 10px;
}
.login-form>form> div>input{
    width: 100%;
    height: 45px;
    border: none;
    border-radius: 10px;
    font-size: 16px;
}
.login-btn {
  width: 100%;
  height: 45px;
  border: none;
  color: #fff;
  background-color: #64cdff;
  margin: 20px 0 8px 0;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
}
.send-sms{
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #61c1f0;
}
.layer{
   

}

</style>
